import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/conectaLa/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/conectaLa/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/conectaLa/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/conectaLa/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/conectaLa/index.js